module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_3-77b9227821d0a2b4d03a6414c646e4d4.jpg";